import { createReducer } from '@reduxjs/toolkit';
import { logout } from '../types';
import {
  fetchNotes,
  createNote,
  updateNote,
  deleteNote,
} from '../actions/notes';
import type { NotesState } from '../types/notes';

const initialState: NotesState = {
  notes: [],
  loading: false,
  error: null,
};

export const notesReducer = createReducer(initialState, (builder) => {
  builder
    // fetchNotes
    .addCase(fetchNotes.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchNotes.fulfilled, (state, action) => {
      state.loading = false;
      state.notes = action.payload;
    })
    .addCase(fetchNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    // createNote
    .addCase(createNote.fulfilled, (state, action) => {
      state.notes.unshift(action.payload);
    })
    // updateNote
    .addCase(updateNote.fulfilled, (state, action) => {
      const idx = state.notes.findIndex((n) => n.id === action.payload.id);
      if (idx !== -1) state.notes[idx] = action.payload;
    })
    // deleteNote
    .addCase(deleteNote.fulfilled, (state, action) => {
      state.notes = state.notes.filter((n) => n.id !== action.payload);
    })
    // logout
    .addCase(logout, () => initialState);
});
